$(function() {

  function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }

  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }

  window.cartdata = window.themeVariables?.settings?.cart;

  var dftcnnt = 0;
  
  const filteredItems = window.cartdata.items.filter(item => {
  const hasSectionType = item.properties && item.properties._sections_type;
    if (hasSectionType) dftcnnt += item.quantity;
    return hasSectionType;
  });
  window.cartqty = dftcnnt;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    $.getJSON('/cart.js', function(cart){
      window.cartdata = cart;

      if($('.added_to_cart_strip').length > 0){
        var ftcnnt = 0;
  
        const filteredItems = cart.items.filter(item => {
          const hasSectionType = item.properties && item.properties._sections_type;
          if (hasSectionType) ftcnnt += item.quantity;
          return hasSectionType;
        });
        window.cartqty = ftcnnt;
        console.log(filteredItems)
        if(filteredItems.length >= 1){
          if(!$('.added_to_cart_strip').hasClass('active')){
            $('.added_to_cart_strip').addClass('active');
          }
          $('.added_to_cart_strip .cart_quantity_count').html(ftcnnt);
        }else{
          $('.added_to_cart_strip').removeClass('active');
        }
      }

      var totldisc = 0;
      var distitle = '';
      $(cart.items).each(function(i,e){
        console.log(e)
        if(e.line_level_discount_allocations.length && e.line_level_discount_allocations[0].discount_application.type != "discount_code"){
          totldisc += parseInt(e.discounts[0].amount);
          distitle = e.discounts[0].title;
          console.log(distitle);
        }
      });
      console.log(totldisc,'totldisc')
      if(totldisc > 0){
        if(!getCookie('discountshown') && $('cart-drawer').hasClass('active')){
          console.log(distitle)
          $('.free-gift-added-popover_overlay .code').html(distitle);
          var prichtml = Shopify.formatMoney(totldisc);
          $('.free-gift-added-popover_overlay [data-totaldisprice]').html(prichtml.replace('.00',''));
          $('.free-gift-added-popover_overlay').show();
          setCookie('discountshown',true,30);
          setTimeout(function(){
            $('.free-gift-added-popover_overlay').hide();
          },3000);  
        }
        
      }else{
        setCookie('discountshown',false,-1);
      }

      

    });
    
  });

  // $('body').on('submit','product-form-custom form', function(e){
  //   e.preventDefault();
  //   if($(this).find('button[type="submit"]').attr('aria-disabled') == 'true'){
  //     return;
  //   }
  //   $(this).find('button[type="submit"]').attr('aria-disabled', true).addClass('loading');
  //   $(this).find('.loading-overlay__spinner').removeClass('hidden');

  // });

  $('body').on('click','.free-gift-added-popover-footer', function(){
    $(this).closest('.free-gift-added-popover_overlay').hide();
    setCookie('discountshown',true,30);
  })

  $('body').on('click','[data-view-cart]', function(){
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    $.getJSON('/cart.js', function(cart){
      function setCookie(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
      }

      function getCookie(name) {
          var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
          return v ? v[2] : null;
      }

      var totldisc = 0;
      var distitle = '';
      $(cart.items).each(function(i,e){
        if(e.line_level_discount_allocations.length && e.line_level_discount_allocations[0].discount_application.type != "discount_code"){
          totldisc += parseInt(e.discounts[0].amount);
          distitle = e.discounts[0].title;
        }
      });
      if(totldisc > 0){
        if(!getCookie('discountshown') && $('cart-drawer').hasClass('active')){
          $('.free-gift-added-popover_overlay .code').html(distitle);
          var prichtml = Shopify.formatMoney(totldisc);
          $('.free-gift-added-popover_overlay [data-totaldisprice]').html(prichtml.replace('.00',''));
          $('.free-gift-added-popover_overlay').show();
          setCookie('discountshown',true,30);
          setTimeout(function(){
            $('.free-gift-added-popover_overlay').hide();
          },3000);  
        }
        
      }else{
        setCookie('discountshown',false,-1);
      }
    });
    this.cart.open();
  })

  $('body').on('click','.available_offers .offerheading', function(){
    $(this).closest('.offerSection').toggleClass('active');
    $(this).closest('.offerSection').find('.offerContent').slideToggle();
  })
  
  $('body').on('click','.hassabmenu',function(e){
    $(this).toggleClass('active');
    $(this).closest('.menulink_wrapper').find('.has-submenu').slideToggle();
  });

  $('body').on('click','[data-discount-tnc]',function(e){
    $(this).find('svg').toggleClass('active');
    $(this).find('.discount-TnC-content').toggleClass('hidden');
  });

  $('body').on('click','[data-check-offers]',function(e){
    e.preventDefault();
    $('[data-cart-discount-popup]').addClass('active');
  });

  $('body').on('click','[data-cart-discount-popup] [data-apply-discount]',function(e){
    $('body #discount_widget_Kartdiscount #af_kd_custom_coupon_text').val($(this).attr('data-apply-discount'));
    CDSetupInit.couponApplyClick($(this).attr('data-apply-discount'));
    // KDSdk.discountApplyClick();
    $(this).closest('[data-cart-discount-popup]').find('[data-close-drawer]').trigger('click');    
  });

  $('body').on('click','[data-copycode]', function () {
    // Create a temporary textarea
    const copyText = $(this);
    var temp = $('<input>');
    $('body').append(temp);
    temp.val(copyText.attr('data-code')).select();
    
    document.execCommand('copy');
    copyText.html('Copied');
    setTimeout(function(){
      copyText.html('Copy');  
    }, 4000);
    
    temp.remove(); // Remove temporary textarea
    
  });

  var kdDom = document.querySelector('body');
  
  kdDom.addEventListener('KD_discountApplyOnComplete',(e)=>{
    console.log('KD_discountApplyOnComplete', e);
    if(e.detail){    
      $(`[data-apply-discount="${e.detail.total_discount.code}"],[data-apply-aov-discount="${e.detail.total_discount.code}"]`).text('Applied').attr('disabled', 'disabled');
      $('#cart-order-summary .discount-summary').html(`
      <span>Item discounts</span>
      <span class="discount_amount">-${Shopify.formatMoney(e.detail.total_discount.amount * 100)}</span>
      `);
    }
  });
  
  kdDom.addEventListener('KD_removeDiscountClicked', (e) => {
  console.log('KD_removeDiscountClicked', e);
  $(`[data-apply-discount="${e.detail}"],[data-apply-aov-discount="${e.detail}"]`).text('Apply').removeAttr('disabled');
  $('#cart-order-summary .discount-summary').html('');
  });


  
  $('body').on('click', '[data-apply-aov-discount]', function (e) {
    $('body #discount_widget_Kartdiscount #af_kd_custom_coupon_text').val($(this).attr('data-apply-aov-discount'));
    KDSdk.discountApplyClick();
  });

  $('body').on('click','.products-list-page .filter_block', function(){
    $(this).closest('.products-list-page').find(`.card-wrapper`).removeClass('active');
    $(this).closest('.products-list-page').find(`.card-wrapper[data-type="${$(this).attr('data-type')}"]`).addClass('active');
  });

  $('body').on('change','.products-list-page .product_subscription_type input[name="selling_plan"]', function(){
    $(this).closest('.card').find('[data-discount-badge]').html(`${$(this).attr('data-discount-perc')}% OFF`);
  });

  // console.log('closethis_pop');
  // $('body').on('click', '.toast .closethis_pop', function (e) {
  //   console.log('ihhhdhhd');
  //   $(this).closest('.toast').remove();
  // });
  
});


// Confetti effect
const confettiCanvas = document.getElementById("confettiCanvas");
const ctx = confettiCanvas.getContext("2d");
confettiCanvas.width = window.innerWidth;
confettiCanvas.height = window.innerHeight;

let confetti = [];
for (let i = 0; i < 150; i++) {
  confetti.push({
    x: Math.random() * confettiCanvas.width,
    y: Math.random() * confettiCanvas.height - confettiCanvas.height,
    r: Math.random() * 6 + 2,
    d: Math.random() * 10 + 5,
    color: `hsl(${Math.random() * 360}, 70%, 60%)`,
    tilt: Math.random() * 10 - 5
  });
}

function drawConfetti() {
  ctx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
  confetti.forEach(c => {
    ctx.beginPath();
    ctx.fillStyle = c.color;
    ctx.fillRect(c.x, c.y, c.r, c.r);
  });
  updateConfetti();
  requestAnimationFrame(drawConfetti);
}

function updateConfetti() {
  confetti.forEach(c => {
    c.y += c.d / 2;
    c.x += Math.sin(c.tilt);
    if (c.y > confettiCanvas.height) {
      c.y = -10;
      c.x = Math.random() * confettiCanvas.width;
    }
  });
}

drawConfetti();

// Close popup on button click
// document.querySelector(".popup-btn").addEventListener("click", () => {
//   document.getElementById("couponPopup").style.display = "none";
// });

if(document.querySelector('.sale-collection-timer') && $(window).width() < 767){
  const stickyBar = document.querySelector('.sale-collection-timer');

  const headerHeight = parseInt(document.querySelector('.section-header').offsetHeight) || 0;
  const announcementHeight = parseInt(document.querySelector('.announcement-bar').offsetHeight) || 0;

  const stickyOffset = stickyBar.offsetTop - (headerHeight + announcementHeight);
  console.log(stickyOffset, headerHeight , announcementHeight)
  window.addEventListener('scroll', function() {
    if (window.scrollY > stickyOffset) {
      stickyBar.classList.add('is-sticky');
    } else {
      stickyBar.classList.remove('is-sticky');
    }
  });
}